import { zodResolver } from '@hookform/resolvers/zod';
import { assert } from 'assert-ts';
import { useForm } from 'react-hook-form';
import { SelectItem } from '#components/patterns/forms/select/select-item/SelectItem.tsx';
import { SelectControlled } from '#components/patterns/forms/select/select/SelectControlled.tsx';
import { Spacer } from '#components/patterns/spacer/Spacer.tsx';
import { routeFormSchema, type RouteFormData } from './route-schema.ts';

const DEFAULT_VALUES = {
  routeId: '',
};

type Props = {
  routeOptions: Array<{
    label: string;
    value: `route-${string}`;
  }>;
  onSave: (cidrConfig: RouteFormData) => void;
};

export function RouteSubscriptionForm({ routeOptions, onSave }: Props) {
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    resolver: zodResolver(routeFormSchema),
    defaultValues: DEFAULT_VALUES,
  });

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    return handleSubmit((data) => {
      return Promise.resolve(onSave(data));
    })(e);
  };

  return (
    <form action="post" id="add-route" onSubmit={onSubmit}>
      <Spacer direction="vertical" size="wide">
        <SelectControlled
          label="Add Route"
          name="routeId"
          control={control}
          hasError={Boolean(errors.routeId)}
          errorMessage={errors.routeId ? errors.routeId.message : undefined}
          placeholder="Please select…"
          renderOptions={({ onChange }) => (
            <>
              {routeOptions.map((itm) => (
                <SelectItem key={itm.value} value={itm.value} onClick={() => onChange(itm.value)}>
                  {itm.label}
                </SelectItem>
              ))}
            </>
          )}
          renderValue={(routeId) => {
            if (!routeId) return '';
            return assert(
              routeOptions.find(
                ({ value }) => value === routeId,
                'Expected every route in the select to exist in routes array'
              )
            ).label;
          }}
        />
      </Spacer>
    </form>
  );
}
